import { messagingService } from './messaging.service';
import { FormError } from '../model/form-error';

class FormErrorService {
    public handleFormErrors(errors: Record<string, FormError>) {
        const allErrors: string[] = [];

        // TODO for now just display as popups, when we got time hook forms into the service.
        this.reduceErrors(allErrors, errors);

        if (0 < allErrors.length) {
            messagingService.showError(allErrors.join(','));
        }
    }

    public reduceErrors(errArray: string[], errors: Record<string, FormError>): void {
        for (const key of Object.keys(errors)) {
            if (errors[key].errors && 0 < errors[key].errors.length) {
                errArray.push(`${key}: ${errors[key].errors.join('; ')}`);
            }

            if (errors[key].children) {
                this.reduceErrors(errArray, errors[key].children);
            }
        }
    }
}

export const formErrorService = new FormErrorService();
